import React, { useState, useRef, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Link, useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Fingerprint2 from "fingerprintjs2";
import Cookies from "js-cookie";
import {
  SITENAMEALIAS,
  SITENAME,
  LOGO,
  CAPTCHASITEKEY,
  DEMOBROKER,
  WEBSERVICE,
} from "../utils/init";
import { updateFavicon } from "../utils/favicon";
import { showToast, showHttpError } from "../utils/library";
import {
  MerchantLogin,
  FetchMerchantStatus,
  TwoFactorLogin,
  CaptchaVerify,
  checkTwoFactorAuth,
  getSignUpPhoneOtp,
  userPhoneSmsOtpVerification,
  smsAuthPhoneOtp,
  emailValidationAtLogin,
  checkMgaStatus,
  loginDetails,
  getBrokerDetails,
  getBrokerDetailsByBrokerId,
  getAuthToken,
} from "../utils/service";
import PaybitoCaptcha from "../components/PaybitoCaptcha";
import Loader from "../components/Loader";
import { useDispatch } from "react-redux";
import logo from "../assets/images/paybitologo.png";
import Header from "../components/Header";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  // On https://trade.paybito.com, if localStorage already has the
  // auto-login credentials, send the user straight to /autologin so they
  // never see the login form. Computed synchronously to prevent UI flash.
  const isTradePaybito = window.location.origin === "https://trade.paybito.com";
  const tradeHasCreds = !!getAuthToken();

  const shouldRedirectToAutoLogin = isTradePaybito && tradeHasCreds;

  // State declarations
  const [showLoader, setShowLoader] = useState(false);
  const [isRememberMe, setIsRememberMe] = useState(false);
  const [isTwoFactorAuthEnabled, setIsTwoFactorAuthEnabled] = useState(false);
  const [isGoogleAuthEnabled, setIsGoogleAuthEnabled] = useState(false);
  const [isPhoneAuthEnabled, setIsPhoneAuthEnabled] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const [showCaptchaModal, setShowCaptchaModal] = useState(false);
  const [isLoginButtonEnable, setIsLoginButtonEnable] = useState(false);
  const [signInPswdType, setSignInPswdType] = useState(false);
  const [isSignInPasswordActive, setIsSignInPasswordActive] = useState(false);
  const [eye, setEye] = useState(true);
  const [passwordType, setPasswordType] = useState("password");
  const [type, setType] = useState(false);
  const [verifySmsOtp, setVerifySmsOtp] = useState(true);
  const [getOtpBtn, setGetOtpBtn] = useState(true);
  const [isTimerStart, setIsTimerStart] = useState(false);
  const [timertxt, setTimertxt] = useState("");
  const [smsOtpSecondStatusCheck, setSmsOtpSecondStatusCheck] = useState(false);
  const [authBtn, setAuthBtn] = useState(true);
  const [secondStatusCheckForEmailOtp, setSecondStatusCheckForEmailOtp] =
    useState(false);
  const [timerTxtEmail, setTimerTxtEmail] = useState("");
  const [isTimerStartEmailGetCode, setIsTimerStartEmailGetCode] =
    useState(false);
  const [loginEmailOtp, setLoginEmailOtp] = useState("");
  const [loginBtn, setLoginBtn] = useState(true);
  const [phoneAuthEnabled, setPhoneAuthEnabled] = useState(false);
  const [googleAuthEnabled, setGoogleAuthEnabled] = useState(false);
  const [googleAuthOtp, setGoogleAuthOtp] = useState("");
  const [userSmsOtpVal, setUserSmsOtpVal] = useState("");
  const [exchangeLogo, setExchangeLogo] = useState("");
  const [exchangeLogoStatus, setExchangeLogoStatus] = useState(false);
  const [backgroundColour, setBackgroundColour] = useState("");
  const [navbarColor, setNavbarColor] = useState("");
  const [buttonColor, setButtonColor] = useState("");
  const [backgroundImageStatus, setBackgroundImageStatus] = useState(0);
  const [backgroundImageLink, setBackgroundImageLink] = useState("");
  const [gRecaptchaResponse, setGRecaptchaResponse] = useState("");
  const [exchangeName, setExchangeName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [brokerId, setBrokerId] = useState("");
  const [emailVerificationModal, setEmailVerificationModal] = useState(false);
  const [showPaybitoOtpModal, setShowPaybitoOtpModal] = useState(false);

  // Refs
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const otpRef = useRef(null);
  const recaptchaRef = useRef(null);
  const captchaRef = useRef(null);
  const googleotpRef = useRef(null);
  const userSmsOtpRef = useRef(null);

  // Handlers
  const handleRememberMe = () => {
    setIsRememberMe(!isRememberMe);
  };

  const fetchBrokerDetailsByBrokerId = useCallback((brokerId) => {
    if (!brokerId) {
      console.error("No broker ID provided to fetchBrokerDetailsByBrokerId");
      return;
    }

    console.log("Fetching broker details for broker ID:", brokerId);

    getBrokerDetailsByBrokerId(brokerId)
      .then((res) => {
        console.log("Broker details response:", res.data);

        var bakgColor =
          "linear-gradient(90deg, " +
          res.data.color.backgroundColor1 +
          " 0%, " +
          res.data.color.backgroundColor2 +
          " 60%)";

        localStorage.setItem(SITENAMEALIAS + "_backgroundColour", bakgColor);
        localStorage.setItem(
          SITENAMEALIAS + "_navbarColour",
          res.data.color.navbarColor
        );
        localStorage.setItem(
          SITENAMEALIAS + "_buttonColour",
          res.data.color.buttonColor
        );

        localStorage.setItem(
          SITENAMEALIAS + "_isBackgroundImage",
          res.data.color.isBackgroundImage
        );

        localStorage.setItem(
          SITENAMEALIAS + "_backgroundImageLink",
          res.data.color.backgroundImageLink
        );

        setExchangeName(res.data.value[0].exchange);
        setExchangeLogo(res.data.value[0].exchange_logo);
        setCompanyName(res.data.value[0].company_name);
        setBackgroundColour(bakgColor);
        setNavbarColor(res.data.color.navbarColor);
        setButtonColor(res.data.color.buttonColor);
        setBackgroundImageStatus(res.data.color.isBackgroundImage);
        setBackgroundImageLink(res.data.color.backgroundImageLink);

        localStorage.setItem(
          SITENAMEALIAS + "_supportLink",
          res.data.value[0].support_link
        );

        // Always update localStorage with the latest broker details
        localStorage.setItem(
          SITENAMEALIAS + "_companyName",
          res.data.value[0].company_name
        );
        localStorage.setItem(
          SITENAMEALIAS + "_exchange",
          res.data.value[0].exchange
        );
        localStorage.setItem(
          SITENAMEALIAS + "_exchangeLogo",
          res.data.value[0].exchange_logo
        );
        updateFavicon();

        console.log("Broker configuration loaded successfully");
      })
      .catch((err) => {
        console.error("Error fetching broker details by ID:", err);
        showToast("error", "Unable to load broker configuration");
      });
  }, []);

  const getBrokerDetailsP = useCallback(() => {
    const fixedBrokerId = "ATHA24102025105924";
    const urlParams = new URLSearchParams(window.location.search);
    const brokerId = urlParams.get("broker-id") || localStorage.getItem(SITENAMEALIAS + "_brokerId") || fixedBrokerId;

    localStorage.setItem(SITENAMEALIAS + "_brokerId", brokerId);
    localStorage.setItem(SITENAMEALIAS + "_broker_id", brokerId);
    localStorage.setItem("DEMOBROKERID", brokerId);

    fetchBrokerDetailsByBrokerId(brokerId);
  }, [fetchBrokerDetailsByBrokerId]);

  const getBrokerDetailsByDomain = useCallback(() => {
    const brokerId = "ATHA24102025105924";
    localStorage.setItem(
      SITENAMEALIAS + "_brokerDomain",
      window.location.origin
    );
    localStorage.setItem(SITENAMEALIAS + "_brokerId", brokerId);
    localStorage.setItem(SITENAMEALIAS + "_broker_id", brokerId);
    fetchBrokerDetailsByBrokerId(brokerId);
  }, [fetchBrokerDetailsByBrokerId]);

  const handleLogin = () => {
    if (
      emailRef.current.value != "" &&
      passwordRef.current.value != "" &&
      captchaValue != ""
    ) {
      setShowLoader(true);
      let payload = {
        email: emailRef.current.value,
        email_otp: loginEmailOtp,
        password: passwordRef.current.value,
        // gRecaptchaResponse: captchaValue,
      };
      MerchantLogin(payload)
        .then((res) => {
          var response = res.data[0];
          console.log(response);
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            setShowLoader(false);
            setShowCaptchaModal(false);
            setEmailVerificationModal(false);
            setCaptchaValue("");

            localStorage.setItem(
              SITENAMEALIAS + "_merchant_id",
              response["merchant_id"]
            );
            localStorage.setItem(SITENAMEALIAS + "_is_remember", isRememberMe);
            localStorage.setItem(
              SITENAMEALIAS + "_first_name",
              response["first_name"]
            );
            localStorage.setItem(
              SITENAMEALIAS + "_last_name",
              response["last_name"]
            );
            localStorage.setItem(SITENAMEALIAS + "_email", response["email"]);
            localStorage.setItem(
              SITENAMEALIAS + "_is_phone_auth_enabled",
              response["phone_auth_enabled"]
            );
            localStorage.setItem(
              SITENAMEALIAS + "_password",
              passwordRef.current.value
            );
            localStorage.setItem(
              SITENAMEALIAS + "_phoneno",
              response["phone"]
            );

            const authorizeClientId = localStorage.getItem("authorize_clientId");
            if (authorizeClientId) {
              const redirectUrl = localStorage.getItem("authorize_redirectUrl");
              const scopes = localStorage.getItem("authorize_scopes");
              const state = localStorage.getItem("authorize_state");

              history.push(
                `/authorize?clientId=${encodeURIComponent(
                  authorizeClientId
                )}&redirectUrl=${encodeURIComponent(
                  redirectUrl || ""
                )}&scopes=${encodeURIComponent(
                  scopes || ""
                )}&state=${encodeURIComponent(state || "")}`
              );
            } else if (response.two_factor_auth_enabled == "1") {
              setIsTwoFactorAuthEnabled(true);
            } else if (response.google_auth_enabled == "1") {
              setIsGoogleAuthEnabled(true);
            } else if (response.phone_auth_enabled == "1") {
              setIsPhoneAuthEnabled(true);
            } else {
              let accessToken = response.oauth2.access_token;
              let uuid = response.uuid;
              console.log("uuid is ", uuid);
              localStorage.setItem(
                SITENAMEALIAS + "_access_token",
                accessToken
              );
              localStorage.setItem(SITENAMEALIAS + "_uuid", uuid);
              setIsTwoFactorAuthEnabled(false);
              setIsGoogleAuthEnabled(false);
              setIsPhoneAuthEnabled(false);
              handleMerchantStatus();
            }
          }
        })
        .catch((err) => {
          setShowLoader(false);
          setShowCaptchaModal(false);
          setCaptchaValue("");
          showHttpError(err);
        });
    } else {
      setShowCaptchaModal(false);
      setCaptchaValue("");
      showToast(
        "error",
        "Please provide valid email address, password and captcha"
      );
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  const setStateHandler = (newState) => {
    // This function handles state updates from child components
    Object.keys(newState).forEach((key) => {
      switch (key) {
        case "showCaptchaModal":
          setShowCaptchaModal(newState[key]);
          break;
        case "captchaValue":
          setCaptchaValue(newState[key]);
          break;
        // Add other state updates as needed
      }
    });
  };

  const billbitCoinLogin = () => {
    let payload = {
      email: emailRef.current.value,
      password: passwordRef.current.value,
    };
    if (loginEmailOtp != "") {
      payload["email_otp"] = loginEmailOtp;
    }
    if (googleAuthOtp != "") {
      payload["google_Factor_Otp"] = googleAuthOtp;
    }
    loginDetails(payload).then((res) => {
      setShowLoader(false);
      var response = res.data;
      if (response.error != "0") {
        showToast("error", response.error_msg);
      } else {
        localStorage.setItem(
          SITENAMEALIAS + "_merchant_id",
          response["merchant_id"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_merchant_uuid",
          response["uuid"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_exchange_uuid",
          response["exchangeUserUuid"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_first_name",
          response["first_name"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_last_name",
          response["last_name"]
        );
        localStorage.setItem(SITENAMEALIAS + "_email", response["email"]);
        localStorage.setItem(
          SITENAMEALIAS + "_password",
          passwordRef.current.value
        );
        localStorage.setItem(SITENAMEALIAS + "_phoneno", response["phone"]);
        localStorage.setItem(
          SITENAMEALIAS + "_email_confirmed",
          response["email_confirmed"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_basic_verification_submitted",
          response["basic_verification_submitted"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_crypto_address_added",
          response["crypto_address_added"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_account_status_id",
          response["account_status_id"]
        );

        let accessToken = response.oauth2.access_token;
        let uuid = response.uuid;
        localStorage.setItem(SITENAMEALIAS + "_access_token", accessToken);
        localStorage.setItem(SITENAMEALIAS + "_uuid", uuid);
        localStorage.setItem(
          SITENAMEALIAS + "_parent_merchant_id",
          response["parent_merchant_id"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_broker_id",
          response["brokerId"]
        );
        // localStorage.setItem(SITENAMEALIAS + "_brokerId", response["brokerId"]);
        localStorage.setItem(
          SITENAMEALIAS + "_home_currency",
          response["homeCurrency"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_home_country",
          response["country"]
        );
        localStorage.setItem(
          SITENAMEALIAS + "_access_list",
          JSON.stringify(response["access_list"])
        );
        localStorage.setItem(SITENAMEALIAS + "_country", response["country"]);
        localStorage.setItem("cdforemail", "");
        localStorage.setItem(
          SITENAMEALIAS + "_created_on",
          response["created_on"]
        );

        const authorizeClientId = localStorage.getItem("authorize_clientId");
        if (authorizeClientId) {
          const redirectUrl = localStorage.getItem("authorize_redirectUrl");
          const scopes = localStorage.getItem("authorize_scopes");
          const state = localStorage.getItem("authorize_state");

          history.push(
            `/authorize?clientId=${encodeURIComponent(
              authorizeClientId
            )}&redirectUrl=${encodeURIComponent(
              redirectUrl || ""
            )}&scopes=${encodeURIComponent(
              scopes || ""
            )}&state=${encodeURIComponent(state || "")}`
          );
        } else {
          handleMerchantStatus();
        }
      }
    });
  };

  const handleEmailOtp = async () => {
    try {
      const { token } = await captchaRef.current.verify();
      handleCaptchaSubmit(token);
    } catch (err) {
      showToast("error", err.message || "Captcha verification failed");
    }
  };

  const handleCaptchaSubmit = (captcha) => {
    // Always get brokerId from URL params first, then localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const brokerId =
      urlParams.get("broker-id") ||
      localStorage.getItem(SITENAMEALIAS + "_brokerId") ||
      localStorage.getItem("DEMOBROKERID");

    let payload = {
      email: emailRef.current.value,
      password: passwordRef.current.value,
      gRecaptchaResponse: captcha,
      brokerId: brokerId,
    };
    checkMgaStatus(payload)
      .then((res) => {
        let response = res.data;
        console.log(res.data);
        if (response.error != "0") {
          showToast("error", response.error_msg);
          recaptchaRef.current?.reset();
        } else {
          if (!isTimerStartEmailGetCode) {
            sendEmailOtp();
          }
          setShowLoader(true);
          setTimeout(() => {
            localStorage.setItem(SITENAMEALIAS + "_phone", response.phone);
            localStorage.setItem(
              SITENAMEALIAS + "_is_google_auth_enabled",
              response.google_auth_enabled
            );
            localStorage.setItem(
              SITENAMEALIAS + "_is_phone_auth_enabled",
              response.phone_auth_enabled
            );

            setEmailVerificationModal(true);
            setCaptchaValue(captcha);
            setShowLoader(false);
            if (response.phone_auth_enabled == "1") {
              setPhoneAuthEnabled(true);
            }
            if (response.google_auth_enabled == "1") {
              setGoogleAuthEnabled(true);
            }
          }, 1000);
        }
      })
      .catch((err) => {
        showHttpError(err);
      });
  };

  const handleAuthLogin = (e) => {
    e.preventDefault();
    var isGoogleAuthTooEnabled = localStorage.getItem(
      SITENAMEALIAS + "_is_google_auth_enabled"
    );
    var isPhoneAuthTooEnabled = localStorage.getItem(
      SITENAMEALIAS + "_is_phone_auth_enabled"
    );

    if (otpRef.current.value != "" && otpRef.current.value != undefined) {
      let payload = {
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
        two_factor_otp: otpRef.current.value,
        password: localStorage.getItem(SITENAMEALIAS + "_password"),
      };
      setShowLoader(true);

      TwoFactorLogin(payload)
        .then((res) => {
          setShowLoader(false);
          setShowCaptchaModal(false);
          setCaptchaValue("");

          var response = res.data[0];

          if (response.error != "0") {
            showToast("error", response.error_msg);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            let accessToken = response.oauth2.access_token;
            let uuid = response.uuid;
            localStorage.setItem(SITENAMEALIAS + "_access_token", accessToken);
            localStorage.setItem(SITENAMEALIAS + "_uuid", uuid);
            if (isGoogleAuthTooEnabled == "1") {
              setIsTwoFactorAuthEnabled(false);
              setIsGoogleAuthEnabled(true);
            } else if (isPhoneAuthTooEnabled == "1") {
              setIsTwoFactorAuthEnabled(false);
              setIsGoogleAuthEnabled(false);
              setIsPhoneAuthEnabled(true);
            } else {
              handleMerchantStatus();
            }
          }
        })
        .catch((err) => {
          setShowLoader(false);
          setShowCaptchaModal(false);
          setCaptchaValue("");
          showHttpError(err);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        });
    } else {
      setShowCaptchaModal(false);
      setCaptchaValue("");
      showToast("error", "Please provide valid OTP");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  const handleGoogleAuthLogin = (e) => {
    e.preventDefault();
    var isPhoneAuthTooEnabled = localStorage.getItem(
      SITENAMEALIAS + "_is_phone_auth_enabled"
    );
    if (
      googleotpRef.current.value != "" &&
      googleotpRef.current.value != undefined
    ) {
      let payload = {
        email: localStorage.getItem(SITENAMEALIAS + "_email"),
        otp: googleotpRef.current.value,
        password: localStorage.getItem(SITENAMEALIAS + "_password"),
      };
      setShowLoader(true);

      checkTwoFactorAuth(payload)
        .then((res) => {
          setShowLoader(false);
          setShowCaptchaModal(false);
          setCaptchaValue("");

          var response = res.data[0];

          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (isPhoneAuthTooEnabled == "1") {
              setIsGoogleAuthEnabled(false);
              setIsPhoneAuthEnabled(true);
            } else {
              let accessToken = response.oauth2.access_token;
              let uuid = response.uuid;
              localStorage.setItem(
                SITENAMEALIAS + "_access_token",
                accessToken
              );
              localStorage.setItem(SITENAMEALIAS + "_uuid", uuid);
              localStorage.setItem(SITENAMEALIAS + "_theme", "dark");
              handleMerchantStatus();
            }
          }
        })
        .catch((err) => {
          console.log(err.toString());
          setShowLoader(false);
          setShowCaptchaModal(false);
          setCaptchaValue("");
          showHttpError(err);
        });
    } else {
      setShowCaptchaModal(false);
      setCaptchaValue("");
      showToast("error", "Please provide valid OTP");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  const handleMerchantStatus = () => {
    setShowLoader(true);
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    FetchMerchantStatus(payload)
      .then((res) => {
        setShowLoader(false);
        var response = res.data[0];
        if (response.error != "0") {
          showToast("error", response.error_msg);
        } else {
          localStorage.setItem(
            SITENAMEALIAS + "_email_confirmed",
            response["email_confirmed"]
          );
          localStorage.setItem(
            SITENAMEALIAS + "_basic_verification_submitted",
            response["basic_verification_submitted"]
          );
          localStorage.setItem(
            SITENAMEALIAS + "_crypto_address_added",
            response["crypto_address_added"]
          );
          localStorage.setItem(
            SITENAMEALIAS + "_account_status_id",
            response["account_status_id"]
          );

          const transaction_status_flag = response["transaction_status_flag"];

          const loginFor = localStorage.getItem(
            SITENAMEALIAS + "_login_for"
          );
          const redirectPath = localStorage.getItem(
            SITENAMEALIAS + "_redirect_path"
          );

          if (loginFor) {
            localStorage.removeItem(SITENAMEALIAS + "_login_for");
            let cleanPath = loginFor;
            if (cleanPath.startsWith("/")) {
              cleanPath = cleanPath.substring(1);
            }
            window.location.href = `${window.location.origin}/${cleanPath}`;
          } else if (redirectPath) {
            localStorage.removeItem(SITENAMEALIAS + "_redirect_path");
            history.push(redirectPath);
          } else {
            if (transaction_status_flag === 0) {
              history.push("/get-started");
            } else {
              history.push("/dashboard");
            }
          }
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const sendOtpForPhoneAuth = () => {
    let payload = {
      email: emailRef.current.value,
      password: passwordRef.current.value,
      phone: localStorage.getItem(SITENAMEALIAS + "_phone"),
    };
    smsAuthPhoneOtp(payload)
      .then((res) => {
        let response = res.data[0];

        if (response.error != "0") {
          showToast("error", response.error_msg);
        } else {
          setVerifySmsOtp(false);
          setGetOtpBtn(false);
          setSmsOtpSecondStatusCheck(true);
          setIsTimerStart(!isTimerStart);
          localStorage.setItem("smsOtpSecondStatusCheck", "true");
          let count = "120";
          localStorage.setItem("smsOtpCd", count);
          smsOtpTimer(120);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const smsOtpTimer = (i) => {
    let count = i;

    setTimertxt(count);
    let downloadTimer = setInterval(() => {
      if (count <= 1) {
        clearInterval(downloadTimer);
        setSmsOtpSecondStatusCheck(false);
        setVerifySmsOtp(true);
        setGetOtpBtn(true);
        localStorage.setItem("smsOtpSecondStatusCheck", "false");
        setIsTimerStart(false);
      }
      count -= 1;
      localStorage.setItem("smsOtpCd", count);
      setTimertxt(localStorage.getItem("smsOtpCd"));
    }, 1000);
  };

  const userPhoneAuthVerify = (e) => {
    e.preventDefault();
    if (
      userSmsOtpRef.current.value != "" &&
      userSmsOtpRef.current.value != undefined
    ) {
      let payload = {
        phone: localStorage.getItem(SITENAMEALIAS + "_phoneno"),
        phone_otp: userSmsOtpRef.current.value,
        password: localStorage.getItem(SITENAMEALIAS + "_password"),
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };

      userPhoneSmsOtpVerification(payload)
        .then((res) => {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
            setUserSmsOtpVal("");
          } else {
            let accessToken = response.oauth2.access_token;
            let uuid = response.uuid;
            localStorage.setItem(SITENAMEALIAS + "_access_token", accessToken);
            localStorage.setItem(SITENAMEALIAS + "_uuid", uuid);
            handleMerchantStatus();
          }
        })
        .catch((err) => {
          setShowLoader(false);
          showHttpError(err);
        });
    } else {
      setShowCaptchaModal(false);
      setCaptchaValue("");
      showToast("error", "Please provide valid OTP");
    }
  };

  const handleVerifyCapthcha = (token) => {
    setShowLoader(true);
    let payload = {
      gRecaptchaResponse: token,
    };
    CaptchaVerify(payload)
      .then((res) => {
        setShowLoader(false);
        var response = res;
        console.log(response);
        if (response.data != "success") {
          showToast("error", response.statusText);
        } else {
          setIsLoginButtonEnable(true);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const sendEmailVerificationMail = (e) => {
    e.preventDefault();
    sendEmailOtp();
  };

  const startTimerForEmailOtp = (i) => {
    let count = i;

    setTimerTxtEmail(count);
    let downloadTimer = setInterval(() => {
      if (count <= 1) {
        clearInterval(downloadTimer);
        setSecondStatusCheckForEmailOtp(false);
        localStorage.setItem("secondStatusCheckForEmailOtp", "false");
        setIsTimerStartEmailGetCode(false);
      }
      count -= 1;
      localStorage.setItem("cdforemail", count);
      setTimerTxtEmail(localStorage.getItem("cdforemail"));
    }, 1000);
  };

  const sendEmailOtp = () => {
    let payload = {
      email: emailRef.current.value,
      password: passwordRef.current.value,
      gRecaptchaResponse: captchaValue,
    };
    emailValidationAtLogin(payload).then((res) => {
      let response = res.data[0];
      if (response.error != "0") {
        showToast("error", response.error_msg);
      } else {
        showToast(
          "success",
          "OTP has been sent to your registered email successfully"
        );
        setIsTimerStartEmailGetCode(!isTimerStartEmailGetCode);
        setLoginBtn(false);
        setSecondStatusCheckForEmailOtp(true);
        localStorage.setItem("secondStatusCheckForEmailOtp", "true");
        let count = "120";
        localStorage.setItem("cdforemail", count);
        startTimerForEmailOtp(120);
      }
    });
  };

  const validEmailOtp = (e) => {
    const value = e.target.value;
    setLoginEmailOtp(value);
    setLoginBtn(!/^[0-9]{7,7}$/.test(value));
  };

  const handleOnCaptchaChange = (value) => {
    console.log("Captcha Value", value);
    setCaptchaValue(value);
    setIsLoginButtonEnable(true);
  };

  const Eye = () => {
    if (passwordType == "password") {
      setPasswordType("text");
      setEye(false);
      setType(true);
    } else {
      setPasswordType("password");
      setEye(true);
      setType(false);
    }
  };

  const handleCaptchaModalClose = () => {
    setShowCaptchaModal(false);
  };

  const generateUUID = () => {
    Fingerprint2.get((components) => {
      const values = components.map((component) => component.value);
      const hash = Fingerprint2.x64hash128(values.join(""), 31);

      localStorage.setItem("deviceId", hash);
      Cookies.set("deviceID", hash, { expires: 60 });
    });
  };

  // Effects
  useEffect(() => {
    setCaptchaValue("");

    // Capture login-for query parameter if present in URL
    const urlParams = new URLSearchParams(window.location.search);
    const loginFor = urlParams.get("login-for");
    if (loginFor) {
      localStorage.setItem(SITENAMEALIAS + "_login_for", loginFor);
    }

    // On trade.paybito.com, hand off to /autologin when localStorage
    // credentials are present. Use replace so /login is not left in history.
    if (shouldRedirectToAutoLogin) {
      history.replace("/autologin");
      return;
    }

    // Check for paybito launch platform cookies — if present, redirect to auto-login
    const cookieToken = Cookies.get("paybito_launch_platform_token");
    const cookieBrokerId = Cookies.get("paybito_launch_platform_broker_id");
    const cookieUuid = Cookies.get("paybito_launch_platform_uuid");
    if (cookieToken && cookieBrokerId && cookieUuid && !isTradePaybito) {
      history.replace("/autologin");
      return;
    }
  }, []);

  useEffect(() => {
    if (shouldRedirectToAutoLogin) return;
    generateUUID();
    getBrokerDetailsP();

    if (localStorage.getItem("smsOtpSecondStatusCheck") == "true") {
      smsOtpTimer(localStorage.getItem("smsOtpCd"));
      setSmsOtpSecondStatusCheck(true);
      setIsTimerStart(true);
      setTimertxt(localStorage.getItem("smsOtpCd"));
      setVerifySmsOtp(false);
    } else {
      setSmsOtpSecondStatusCheck(false);
      setVerifySmsOtp(true);
    }

    if (localStorage.getItem("secondStatusCheckForEmailOtp") == "true") {
      startTimerForEmailOtp(localStorage.getItem("cdforemail"));
      setSecondStatusCheckForEmailOtp(true);
      setIsTimerStartEmailGetCode(true);
      setTimerTxtEmail(localStorage.getItem("cdforemail"));
      setLoginBtn(false);
    } else {
      setSecondStatusCheckForEmailOtp(false);
    }
  }, [getBrokerDetailsP]);

  console.log("gRecaptchaResponse", gRecaptchaResponse);

  // Skip rendering on trade.paybito.com when localStorage creds are present —
  // the effect above is already replacing the route with /autologin. This
  // prevents the login form from flashing during the redirect.
  // if (shouldRedirectToAutoLogin) {
  //   return null;
  // }

  useEffect(() => {
    updateFavicon(exchangeLogo);
  }, [exchangeLogo]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{localStorage.getItem(SITENAMEALIAS + "_exchange")}</title>
      </Helmet>

      <nav
        className="navbar navbar-light extNavbar"
        style={{
          backgroundColor: navbarColor,
        }}
      >
        <div className="image-container">
          <img src={exchangeLogo} className="logo-cred " />
        </div>
      </nav>

      {backgroundImageStatus == 0 ? (
        <div className="login-wrapper" style={{ background: backgroundColour }}>
          <div className="login-background">
            <div className="row mb-3">
              <div className="col-12 text-center "></div>
            </div>
            <div className="row mb-2 m-0">
              <div className="col-12" style={{ marginTop: "100px" }}>
                <div
                  className="card form-card"
                  style={{ borderRadius: "10px" }}>
                  <div className="card-body cardBody">
                    <h4 className="card-title text-center login-title">
                      {localStorage.getItem(SITENAMEALIAS + "_exchange")}{" "}
                      Merchant Login
                    </h4>
                    {!isTwoFactorAuthEnabled &&
                      !isGoogleAuthEnabled &&
                      !isPhoneAuthEnabled && (
                        <form
                          className="forms-sample"
                          onSubmit={(e) => {
                            e.preventDefault();
                            if (
                              emailRef.current.value != "" &&
                              passwordRef.current.value != ""
                            ) {
                              handleEmailOtp();
                            }
                          }}
                        >
                          <div className="login-float-group">
                            <input
                              type="email"
                              id="loginEmail"
                              ref={emailRef}
                              placeholder=" "
                            />
                            <label htmlFor="loginEmail">Email Address</label>
                          </div>
                          <div className="login-float-group">
                            <input
                              type={passwordType}
                              id="loginPassword"
                              ref={passwordRef}
                              placeholder=" "
                              style={{ paddingRight: "44px" }}
                            />
                            <label htmlFor="loginPassword">Password</label>
                            <span className="password-toggle" onClick={Eye}>
                              <i
                                className={`fa ${eye ? "fa-eye-slash" : "fa-eye"
                                  }`}
                              ></i>
                            </span>
                          </div>
                          <button type="submit" className="login-btn">
                            Log in
                          </button>
                        </form>
                      )}
                    {isTwoFactorAuthEnabled && (
                      <form
                        className="forms-sample"
                        onSubmit={(event) => {
                          handleAuthLogin(event);
                        }}
                      >
                        <p className="login-hint-text">
                          Enter <b>one time password</b> received in your
                          registered email address
                        </p>
                        <div className="login-float-group">
                          <input
                            type="password"
                            id="otpInput"
                            ref={otpRef}
                            placeholder=" "
                          />
                          <label htmlFor="otpInput">One Time Password</label>
                        </div>
                        <button type="submit" className="login-btn">
                          Authenticate
                        </button>
                      </form>
                    )}
                    {isGoogleAuthEnabled && (
                      <form
                        className="forms-sample"
                        onSubmit={(event) => {
                          handleGoogleAuthLogin(event);
                        }}
                      >
                        <p className="login-hint-text">
                          Enter <b>6-digit code</b> from your Google
                          Authenticator App
                        </p>
                        <div className="login-float-group">
                          <input
                            type="number"
                            id="googleOtp"
                            ref={googleotpRef}
                            placeholder=" "
                            onKeyUp={() => {
                              let elm = googleotpRef.current.value;
                              let regex = /^\d{6}$/;
                              if (!regex.test(elm)) {
                                setAuthBtn(true);
                              } else {
                                setAuthBtn(false);
                              }
                            }}
                          />
                          <label htmlFor="googleOtp">
                            Google Authenticator Code
                          </label>
                        </div>
                        <button
                          type="submit"
                          className="login-btn"
                          disabled={authBtn}
                        >
                          Authenticate
                        </button>
                      </form>
                    )}

                    <div className="login-links">
                      {!isTwoFactorAuthEnabled && !isGoogleAuthEnabled && (
                        <Link to="/forgot-password">Reset Password?</Link>
                      )}
                      {!isGoogleAuthEnabled && (
                        <span>
                          Not registered yet? <Link to="/signup">Register</Link>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* window.location.origin == DEMOBROKER */}
          {window.location.origin == DEMOBROKER ? (
            <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
              <a href="https://www.paybito.com/">
                <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                  <img
                    src={logo}
                    alt=""
                    style={{ marginRight: 3, height: "30px" }}
                  />
                  Powered by PayBito infrastructure
                </div>
              </a>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      ) : (
        <div
          className="login-wrapper"
          style={{
            backgroundImage: `url(${backgroundImageLink})`,
            backgroundRepeat: `no-repeat`,
            backgroundSize: `cover`,
            backgroundPosition: `center`,
            minHeight: `100%`,
          }}
        >
          <div className="login-background">
            <div className="row mb-3">
              <div className="col-12 text-center "></div>
            </div>
            <div className="row mb-2 m-0">
              <div className="col-12" style={{ marginTop: "100px" }}>
                <div
                  className="card form-card"
                  style={{ borderRadius: "10px" }}
                >
                  <div className="card-body cardBody">
                    <h4 className="card-title text-center login-title">
                      Login to{" "}
                      {localStorage.getItem(SITENAMEALIAS + "_exchange")}
                    </h4>
                    {!isTwoFactorAuthEnabled &&
                      !isGoogleAuthEnabled &&
                      !isPhoneAuthEnabled && (
                        <form
                          className="forms-sample"
                          onSubmit={(e) => {
                            e.preventDefault();
                            if (
                              emailRef.current.value != "" &&
                              passwordRef.current.value != ""
                            ) {
                              handleEmailOtp();
                            }
                          }}
                        >
                          <div className="login-float-group">
                            <input
                              type="email"
                              id="loginEmail"
                              ref={emailRef}
                              placeholder=" "
                            />
                            <label htmlFor="loginEmail">Email Address</label>
                          </div>
                          <div className="login-float-group">
                            <input
                              type={passwordType}
                              id="loginPassword"
                              ref={passwordRef}
                              placeholder=" "
                              style={{ paddingRight: "44px" }}
                            />
                            <label htmlFor="loginPassword">Password</label>
                            <span className="password-toggle" onClick={Eye}>
                              <i
                                className={`fa ${eye ? "fa-eye-slash" : "fa-eye"
                                  }`}
                              ></i>
                            </span>
                          </div>
                          <button type="submit" className="login-btn">
                            Log in
                          </button>
                        </form>
                      )}
                    {isTwoFactorAuthEnabled && (
                      <form
                        className="forms-sample"
                        onSubmit={(event) => {
                          handleAuthLogin(event);
                        }}
                      >
                        <p className="login-hint-text">
                          Enter <b>one time password</b> received in your
                          registered email address
                        </p>
                        <div className="login-float-group">
                          <input
                            type="password"
                            id="otpInput"
                            ref={otpRef}
                            placeholder=" "
                          />
                          <label htmlFor="otpInput">One Time Password</label>
                        </div>
                        <button type="submit" className="login-btn">
                          Authenticate
                        </button>
                      </form>
                    )}
                    {isGoogleAuthEnabled && (
                      <form
                        className="forms-sample"
                        onSubmit={(event) => {
                          handleGoogleAuthLogin(event);
                        }}
                      >
                        <p className="login-hint-text">
                          Enter <b>6-digit code</b> from your Google
                          Authenticator App
                        </p>
                        <div className="login-float-group">
                          <input
                            type="number"
                            id="googleOtp"
                            ref={googleotpRef}
                            placeholder=" "
                            onKeyUp={() => {
                              let elm = googleotpRef.current.value;
                              let regex = /^\d{6}$/;
                              if (!regex.test(elm)) {
                                setAuthBtn(true);
                              } else {
                                setAuthBtn(false);
                              }
                            }}
                          />
                          <label htmlFor="googleOtp">
                            Google Authenticator Code
                          </label>
                        </div>
                        <button
                          type="submit"
                          className="login-btn"
                          disabled={authBtn}
                        >
                          Authenticate
                        </button>
                      </form>
                    )}

                    <div className="login-links">
                      {!isTwoFactorAuthEnabled && !isGoogleAuthEnabled && (
                        <Link to="/forgot-password">Forgot Password?</Link>
                      )}
                      {!isGoogleAuthEnabled && (
                        <span>
                          Not registered yet? <Link to="/signup">Register</Link>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <PaybitoCaptcha ref={captchaRef} sitekey={CAPTCHASITEKEY} />

      <Modal
        show={emailVerificationModal}
        backdrop="static"
        keyboard={false}
        dialogClassName="security-auth-modal"
      >
        <Modal.Header>
          <Modal.Title>Security Authentication</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setShowPaybitoOtpModal(!showPaybitoOtpModal);
              setShowLoader(true);
              localStorage.setItem("cdforemail", "");
              window.location.reload();
            }}
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <form className="forms-sample">
            <p className="auth-description">
              Please enter the email code from{" "}
              {localStorage.getItem(SITENAMEALIAS + "_email")
                ? localStorage
                  .getItem(SITENAMEALIAS + "_email")
                  .replace(
                    /^(.{3})(.*)(@.*)$/,
                    (_, a, b, c) => a + "*".repeat(b.length) + c
                  )
                : "your registered email"}
            </p>

            <div className="auth-input-group">
              <input
                type="number"
                className="auth-input"
                value={loginEmailOtp}
                onChange={validEmailOtp}
                placeholder="E-mail verification code"
                onKeyUp={(e) => {
                  let elmVal = e.target.value;
                  let regex = /^[0-9]{7,7}$/;
                  if (regex.test(elmVal)) {
                    if (!googleAuthEnabled) {
                      billbitCoinLogin();
                    } else {
                      setLoginBtn(false);
                    }
                  } else {
                    setLoginBtn(true);
                    if (loginEmailOtp > 9999999) {
                      setLoginEmailOtp("");
                    }
                  }
                }}
              />
            </div>
            {!isTimerStartEmailGetCode ? (
              <span
                className="get-otp-link"
                onClick={sendEmailVerificationMail}
              >
                Get OTP
              </span>
            ) : (
              <span className="resend-timer">
                Resend in {timerTxtEmail} seconds
              </span>
            )}

            {googleAuthEnabled && (
              <>
                <p className="auth-section-label">
                  Input OTP from your Google Authenticator
                </p>
                <div className="auth-input-group">
                  <input
                    type="number"
                    ref={googleotpRef}
                    value={googleAuthOtp}
                    className="auth-input"
                    onChange={(e) => {
                      setGoogleAuthOtp(e.target.value);
                    }}
                    onKeyUp={() => {
                      let elm = googleotpRef.current.value;
                      let regex = /^\d{6}$/;

                      if (!regex.test(elm)) {
                        setLoginBtn(true);
                      } else {
                        setLoginBtn(false);
                      }
                    }}
                    placeholder="Google Authenticator code"
                  />
                </div>
              </>
            )}

            <div className="auth-buttons">
              <button
                type="button"
                className="auth-btn-confirm"
                onClick={billbitCoinLogin}
                disabled={loginBtn}
              >
                Confirm
              </button>
              <button
                type="button"
                className="auth-btn-cancel"
                onClick={() => {
                  setShowPaybitoOtpModal(!showPaybitoOtpModal);
                  setShowLoader(true);
                  localStorage.setItem("cdforemail", "");
                  window.location.reload();
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Loader show={showLoader} />
    </>
  );
};

export default Login;
